import { useEffect } from "react";
import { Outlet } from "@tanstack/react-router";
import { useAuthStore } from "@/stores/auth";
import { api } from "@/lib/api";

export function RootLayout() {
  const { setUser, setIsAdmin, setOrganizations, setLoading } = useAuthStore();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const data = await api.auth.me();
        setUser(data.user);
        setIsAdmin(data.isAdmin || false);
        setOrganizations(data.organizations);
      } catch {
        setUser(null);
        setIsAdmin(false);
        setOrganizations([]);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [setUser, setIsAdmin, setOrganizations, setLoading]);

  return <Outlet />;
}
